export enum CandidateStatusEnum {
    WAITLISTED = 'Waitlisted',
    SHORTLISTED = 'Shortlisted',
    UNSUCCESSFUL = 'Unsuccessful',
    WELLNESS = 'Wellness',
    AGENTIC_ASSESSMENT = 'Agentic-Assessment',
  }
